// import React, { useEffect, useState } from "react";
// import Axios from "../../../services/AxiosInstance";
import { useNavigate } from 'react-router-dom';
import Notification from "../../Notification";


import React, { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";

import ReactPaginate from 'react-paginate';
import UpdatePackageName from './UpdatePackageName';

// import Notification from "../Notification";
// import { Link } from "@material-ui/core";




const PackageList = () => {

    // const Navigate = useNavigate();
    const [package_details, setPackageDetails] = useState([]);
    const [totalPages, setTotalPage] = useState(0);
    const [pageCount, setpageCount] = useState(0);
    const [sortToggle, setSortToggle] = useState(true);

    const [perPage, setPerpage] = useState(process.env.REACT_APP_PER_PAGE);

    const [searchData, setSearchData] = useState('');

    const [once, setOnce] = useState([]);


    const [packageId, setPackageId] = useState('1');
    const [packageName, setPackageName] = useState('');
    const [editName, setEditName] = useState(false);

    const [isPackageNameUpdated, setIsPackageNameUpdated] = useState(false);



    const getPackageList = async () => {
        let res;
        if (searchData) {
            res = await Axios.get(`api/bussiness/package-listing?searchData=${searchData}`);
            console.log(res);
        }
        else {
            res = await Axios.get(`api/bussiness/package-listing?pageNo=1&perPage=${perPage}`);
        }
        setPackageDetails(res.data.data.data);
        console.log(package_details);
        setTotalPage(res.data.data.totalPage);
        setpageCount(res.data.data.totalPage);
        setIsPackageNameUpdated(false);
        console.log(totalPages, pageCount);
        localStorage.removeItem('sort_key');
        localStorage.removeItem('sort_order');
    };

    useEffect(() => {
        getPackageList();
    }, [once, perPage]);

    useEffect(() => {
        getPackageList();
    }, [isPackageNameUpdated])



    const fetchPackageList = async (currentPage) => {
        const sort_key = localStorage.getItem('sort_key');
        const sort_order = localStorage.getItem('sort_order');
        let sortUrl = "";
        if (sort_key && sort_order) {
            sortUrl = `&sortkey=${sort_key}&order=${sort_order}`;
        }
        const res = await Axios.get(`api/bussiness/package-listing?pageNo=${currentPage}&perPage=${perPage}${sortUrl}`);
        await setPackageDetails(res.data.data.data);
        return package_details;
    };


    const handlePageClick = async (data) => {
        let currentPage = data.selected + 1;
        await fetchPackageList(currentPage);
    };





    const handleChange = (e) => {
        const { name, checked } = e.target;
        // console.log(name);


        if (name === "allSelect") {
            let tempUser = package_details.map((plan) => {
                return { ...plan, isChecked: checked };
            });
            console.log(tempUser);
            setPackageDetails(tempUser);
        }
        else {
            let tempUser = package_details.map((plan) =>
                plan.service_id === name ? { ...plan, isChecked: checked } : plan
            );
            console.log(tempUser);
            setPackageDetails(tempUser);
        }
    }



    function HandleEditName(e) {
        console.log(e.target.value);
        setPackageId(e.target.value);
        console.log(package_details.length);
        for (let i = 0; i < package_details.length; i++) {
            if (package_details[i].package_id === e.target.value) {
                setPackageName(package_details[i].package_name);
            }
        }
        setEditName(true);
    }


    const DeleteApi = (e) => {
        console.log(package_details);
        const packageIds = [];
        if (e.target.value) {
            packageIds.push(e.target.value);
        }
        // console.log('hi',package_details[0].package_id);
        for (let i = 0; i < package_details.length; i++) {
            if (package_details[i].isChecked === true) {
                packageIds.push(package_details[i].package_id);
            }
        }
        console.log("hi", packageIds);
        Axios
            .post("api/bussiness/package-delete", {
                packageIdsArr: packageIds
            }).then((res) => {
                console.log(res);
                getPackageList();
            }).catch((error) => {
                console.log(error);
            })

    }


    const Packageitem = package_details.map((plan, index) => {
        return (
            <tr key={index} value={plan.package_id}>
                <td><input
                    type="checkbox"
                    name={plan.package_id}
                    checked={plan?.isChecked || false}
                    onChange={handleChange}
                />
                </td>
                <td>{index + 1}</td>
                <td>{plan.package_name}</td>
                <td>{plan.package_id}</td>
                <td>{plan.service_id}</td>
                <td>{plan.added_by}</td>
                <td>{plan.added_date}</td>
                <td>{plan.status}</td>
                <td >
                    <button value={plan.package_id} name={plan.package_name} onClick={(e) => HandleEditName(e)}>Edit</button>
                    <button value={plan.package_id} onClick={(e) => DeleteApi(e)}>Delete </button>
                </td>
            </tr>
        )
    })


    const handleSortdesc = async (sortkey, order) => {
        if (sortkey) {
            console.log(sortkey, order);
            // alert('I am Decending')
            setSortToggle(true);
            localStorage.setItem("sort_key", sortkey);
            localStorage.setItem("sort_order", order);
            const res = await Axios.get(`api/bussiness/package-listing?pageNo=1&perPage=${perPage}&sortkey=${sortkey}&order=${order}`)
            if (res.data.data.data.length > 0) {
                setPackageDetails(res.data.data.data);
                // setSortToggle(true);
            }
        }
    }



    const handleSortasc = async (sortkey, order) => {
        if (sortkey) {
            console.log(sortkey)
            // alert('I am accending')
            setSortToggle(false);
            localStorage.setItem("sort_key", sortkey)
            localStorage.setItem("sort_order", order)
            const res = await Axios.get(`api/bussiness/package-listing?pageNo=1&perPage=${perPage}&sortkey=${sortkey}&order=${order}`)
            if (res.data.data.data.length > 0) {
                setPackageDetails(res.data.data.data);
            }
        }
    }



    return (
        <>
            <div className="content-page">
                <div className="content">


                    <div className="container-fluid">


                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    <h4 className="page-title">Package List</h4>
                                </div>
                            </div>
                        </div>

                        <div style={{ position: "absolute", right: "30px" }}>
                        </div>

                        <div className="col-md-6 col-xl-3">
                            <div className="card-box">
                                <div className="form-group mb-0 text-center">
                                    <input type="" className='search-product-box' placeholder='Search...'
                                        onChange={(e) => setSearchData(e.target.value)}
                                    />
                                    <button onClick={getPackageList}>Search</button>
                                </div>
                            </div>

                        </div>

                        {
                            editName ? <UpdatePackageName setIsPackageNameUpdated={setIsPackageNameUpdated} setEditName={setEditName} packageId={packageId} packageName={packageName} /> : ""
                        }

                        <div className="row">
                            <div className="card-box table-responsive">
                                <h4 className="header-title"><b>List of Active Services</b></h4>
                                {/* <!-- <p className="sub-header">
                                            Show Listing</code>.
                                        </p> --> */}
                                <button onClick={DeleteApi}>All Delete</button>
                                {
                                    totalPages === 0 ?
                                        <h1>Data Not found</h1>
                                        :
                                        <table id="datatable" className="table table-bordered  dt-responsive nowrap">
                                            <thead>
                                                <tr>
                                                    <td><input
                                                        type="checkbox"
                                                        name="allSelect"
                                                        checked={!package_details.some((plan) => plan?.isChecked !== true)}
                                                        onChange={handleChange}
                                                    />allSelect
                                                    </td>
                                                    <td>S.No</td>
                                                    <td >Package Name
                                                  
                                                    </td>
                                                    <td>Package Id
                                                       
                                                    </td>
                                                    <td>Service Id
                                                       
                                                    </td>
                                                    <td>Added By
                                                    </td>
                                                    <td>Added Date
                                                    </td>
                                                    <td>Status
                                                    </td>
                                                    <td>Action</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Packageitem}
                                            </tbody>

                                        </table>
                                }
                                <ReactPaginate
                                    previousLabel={"previous"}
                                    nextLabel={"next"}
                                    breakLabel={"..."}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={3}
                                    onPageChange={handlePageClick}
                                    containerClassName={"pagination justify-content-center"}
                                    pageClassName={"page-item"}
                                    pageLinkClassName={"page-link"}
                                    previousClassName={"page-item"}
                                    previousLinkClassName={"page-link"}
                                    nextClassName={"page-item"}
                                    nextLinkClassName={"page-link"}
                                    breakClassName={"page-item"}
                                    breakLinkClassName={"page-link"}
                                    activeClassName={"active"}
                                />
                                <span><b>Rows per page:-</b></span>
                                <select name="Rows per page" onChange={(e) => setPerpage(e.target.value)}>
                                    <option>Select Per Page</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="60">60</option>
                                </select>
                            </div>

                        </div>

                    </div>
                </div>


            </div>

        </>

    )
}

export default PackageList;